import EventDispatcher from "js-class.event-dispatcher";

import icon_asterisk from 'bundle-text:../assets/asterisk-solid.svg';
import icon_language from 'bundle-text:../assets/language-solid.svg';

export default class Language {
	constructor(param)
	{
		this.events = new EventDispatcher(this);
		this.param = param.param || {};
		this.languages = param.languages || []
		this.selected = param.selected || null;
		this.dom = null
		this.dom__init();
	}

	on(eventName,callback) { this.events.registerEvent(eventName,callback); }
	off(eventName,callback) { this.events.unregisterEvent(eventName,callback); }
	fire(eventName,data) { this.events.fireEvent(eventName, data); }

	addLanguage(lng) {
		this.languages.push(lng);
	}
	removeLanguage(lng) {
		this.languages = this.languages.filter(l => l !== lng)
	}
	getLanguage() {
		return this.selected;
	}
	setLanguage(lng) {
		this.selected = lng;
		this.dom__refresh()

		this.fire('change');
	}

	getParam(k=null) {
		if(typeof k === 'string')
			return this.param[k];
		return {...this.param};
	}
	setParam(k,v=null) {
		this.param[k] = v;
		this.dom__refresh();
		this.fire('change')
	}
	loadParam(param) {
		this.param = param;
		this.dom__refresh();
	}

	dom__init() {
		this.dom = document.createElement('div')
		//this.dom.appendChild(this.dom__btn(null,icon_asterisk));
		this.dom.appendChild(this.dom__btn(null,icon_asterisk+' ALL'));
		for(let i=0; i<this.languages.length; i++)
			this.dom.appendChild(this.dom__btn(this.languages[i]));
	}

	dom__btn(lng,content=null) {
		const el = document.createElement('button')
		el.setAttribute('type','button');
		if(lng) {
			el.setAttribute('data-lng',lng);
		}
		el.innerHTML = content || lng.toUpperCase();
		el.addEventListener('click',this.setLanguage.bind(this,lng))
		return el;
	}

	dom__refresh() {
		clearTimeout(this.dom__refresh_delay);
		this.dom__refresh_delay = setTimeout(this.dom__refresh_delayed.bind(this),10);
	}

	dom__refresh_delayed() {
		const language = this.getLanguage();
		this.dom.querySelectorAll('button').forEach(el => {
			let lng = el.getAttribute('data-lng') || null;
			if(lng === language)
				el.classList.add('on')
			else
				el.classList.remove('on')

			let provider = lng ? this.param?.i18n?.[lng]?.provider : this.param?.provider;
			if(provider)
				el.setAttribute('provider',provider);
			else
				el.removeAttribute('provider');
		});
	}
}